import React, { useState } from 'react';
import right_arrow from '../../assets/images/leftArrow.svg';
import git_Image from '../../assets/images/git_fork.svg';
import zoom from "../../UserAssets/images/zoom.svg";
import { fetchAllParentChildTreeData } from '../../Redux/Api/fetch.api';
import noimage from "../../UserAssets/images/noImage.jpg";
import QRCodeGenerator from "../UserLogin/QRCodeGenerator";
import { useHistory, useLocation } from 'react-router';
import { Modal } from 'react-bootstrap';

const ParentChildCard = ({ node, updateNode, path, breadcrumbData, }) => {
    const [loading, setloading] = useState(false);
    const [openModel, setOpenModel] = useState(false);
    const { pathname } = useLocation();
    const history = useHistory();

    const getExpandedChildData = async () => {
        if (loading) return;
        setloading(true)
        await fetchAllParentChildTreeData(node.qrCode)
            .then((response) => {
                if (response.data.success) {
                    updateNode(node.qrCode, response.data.data.scanedQRDetails, response.data.data.childQrDetails, path);
                    setloading(false);
                    setloading(false);
                }
                else {
                    history.push("/NotFound");
                }
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }

    const backPage = (qrCode) => {
        history.push({
            pathname: "/QRThumbnail/" + qrCode,
            state: {
                currentId: qrCode,
                breadcrumbData: breadcrumbData,
                topParentId: pathname.split('/').pop()
            },
        });
    };

    const handleZoomButton = () => {
        setOpenModel(true);
    }

    return (
        <div className="boxs">
            <Modal
                show={openModel}
                onHide={() => setOpenModel(false)}
                backdrop="static"
                keyboard={false}
                dialogClassName="modal-dialog-centered"
            >
                <Modal.Header className="pt-3 pb-2" closeButton>
                    <Modal.Title className="h2 pb-1 font-weight-bold">Thumbnail Image</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        <div class="img-section m-0 flex-wrap d-flex align-items-center">
                            <img
                                className='w-100'
                                src={node.thumbnailName || noimage}
                                alt=""
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = noimage;
                                }}
                            />
                        </div>
                    }
                </Modal.Body>
            </Modal>
            <div className="flex-box">
                <div className="image">
                    <img
                        src={node.thumbnailName || noimage}
                        alt=""
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = noimage;
                        }}
                    />
                    <button onClick={handleZoomButton} class="ZoomBtn" >
                        <img src={zoom} alt="Zoom" />
                    </button>
                </div>
                <div className="content">
                    <h5>{node.qrCode ? `QR-${node.qrCode}` : ""}</h5>
                    <p>{node.product_Name || ""}</p>
                </div>
                <div className="qr-detail">
                    <span> {path.length === 0 ? 'Parent QR' : 'The Child QR'}</span>
                    {/* <img src={node.thumbnailName ? node.thumbnailName : noimage} alt="" /> */}
                    <QRCodeGenerator qrcodeid={node.qrCode} />
                </div>
            </div>
            {(node.isExpand) && (
                <span className='imidiate-child-inner' onClick={getExpandedChildData}>
                    <img src={git_Image} alt="" /> {loading ? 'fetching children' : 'Immediate Child'} {loading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                </span>
            )}
            {/* <button onClick={()=> navigate(`/QRThumbnail/${node.qrCode}`)} className="btn"> */}
            <button onClick={() => backPage(node.qrCode)} className="btn">
                <img src={right_arrow} alt="" />
            </button>
        </div>
    )
};

export default ParentChildCard;